import React from "react";
import {
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Pagination,
} from "@mui/material";
import ReceiptTableRow from "./ReceiptTableRowDoctors";
import jMoment from "moment-jalaali";

const ReceiptTable = (props) => {
  const handleChange = (event, value) => {
    props.getPage(value);
  };
  return (
    <>
      <TableContainer component={Paper} aria-label="simple table">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell align="justify">شماره فاکتور</TableCell>
              <TableCell align="justify">تاریخ صدور</TableCell>
              <TableCell align="justify">لابراتوار</TableCell>
              <TableCell align="justify">به نام</TableCell>
              <TableCell align="justify">تعداد کار</TableCell>
              <TableCell align="justify">قیمت مجموع</TableCell>
              <TableCell align="justify">وضعیت پرداخت</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.data &&
              props.data.map((receipt) => {
                return (
                  <ReceiptTableRow
                    key={receipt.id}
                    receiptId={receipt.id}
                    receiptCode={receipt.receiptCode}
                    submissionDate={jMoment(
                      parseInt(receipt.submissionDate)
                    ).format("jYY/jMM/jDD")}
                    laboratory={
                      props.labNames.find(
                        (lab) => lab.id === receipt.laboratoryId
                      )?.name
                    }
                    name={receipt.name}
                    orderCount={receipt.receipts.length}
                    totalPrice={receipt.receiptTotal}
                    isPaid={receipt.isPayed}
                  />
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      {props.pageCount > 1 && (
        <Pagination
          sx={{ mt: 4, justifyContent: "center", display: "flex" }}
          count={props.pageCount}
          onChange={handleChange}
        />
      )}
    </>
  );
};

export default ReceiptTable;
